<div class="fixed w-full h-10 z-10 flex items-center justify-between px-8 bottom-0 pointer-events-none">
  <span class="text-xs font-extralight [text-shadow:_0_0.5px_3.5px_rgb(0_0_0_/_0.8)]">
    {{ !isProdEnvironment() ? appVersion() : ' ' }}
  </span>

  <div class="flex space-x-4">
    @for (link of pages(); track link.slug) {
      <a
        class="flex flex-row items-center hover:cursor-pointer pointer-events-auto text-white"
        [routerLink]="buildRouterLink(link.slug)"
        target="_blank"
        rel="noopener noreferrer"
      >
        <span class="text-xs font-extralight [text-shadow:_0_0.5px_3.5px_rgb(0_0_0_/_0.8)]">{{ link.title }}</span>
      </a>
    }

    @if (showImprint()) {
      <div
        class="flex flex-row items-center hover:cursor-pointer pointer-events-auto"
        [routerLink]="['/', currentProjectSlug(), 'legal', 'imprint']"
      >
        <span class="text-xs font-extralight [text-shadow:_0_0.5px_3.5px_rgb(0_0_0_/_0.8)]">{{ imprintLabel() }}</span>
      </div>
    }

    @if (showPrivacy()) {
      <div
        class="flex flex-row items-center hover:cursor-pointer pointer-events-auto"
        [routerLink]="['/', currentProjectSlug(), 'legal', 'privacy']"
      >
        <span class="text-xs font-extralight [text-shadow:_0_0.5px_3.5px_rgb(0_0_0_/_0.8)]">{{ privacyLabel() }}</span>
      </div>
    }
  </div>
</div>
